import React from "react";
import { motion } from "framer-motion";

const lines = [
  "We buy bags of wood mulch.",
  "We spread it around our homes.",
  "We don't ask where it comes from.",
  "We don't ask what it's doing to our families.",
  "We don't ask what it'll cost us \u2014 this year, next year, the year after that.",
];

export default function Confession() {
  return (
    <section
      data-testid="confession-section"
      className="relative w-full py-32 sm:py-40 px-6 bg-[#0F0F0F]"
    >
      <div className="max-w-3xl mx-auto flex flex-col gap-20 sm:gap-28">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 1.0, ease: "easeOut" }}
          className="font-marker text-[#E8E5DE] text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-center"
        >
          every spring,
          <br />
          we do the same thing.
        </motion.h2>

        <div className="flex flex-col gap-14 sm:gap-20">
          {lines.map((line, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 1.0, delay: i * 0.05, ease: "easeOut" }}
              className="text-lg sm:text-2xl md:text-3xl text-[#E8E5DE] text-center leading-snug font-light"
              data-testid={`confession-line-${i}`}
            >
              {line}
            </motion.p>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.2 }}
          className="font-marker text-[#C4451C] text-4xl sm:text-5xl text-center"
        >
          It's time to ask.
        </motion.p>
      </div>
    </section>
  );
}
